import API from '../../utils/const';
import { authFetch } from '../../utils/session';
import { SyncRule } from '../../utils/rule';
import { SyncRuleFormValues } from './interface';

export function buildSyncRulePayload(values: SyncRuleFormValues, rule: SyncRule | null): Record<string, unknown> {
    const content: Record<string, unknown> = {
        summary: values.summary,
        description: values.description,
        status_transform: values.statusTransform,
        visibility: values.visibility,
        color: values.color === '0' ? null : values.color,
        keep_location: values.keep_location === 'true',
        include_conference_link: values.include_conference_link === 'true',
        transparency: values.transparency,
        buffer: {
            minutes_before: values.bufferBefore,
            minutes_after: values.bufferAfter,
        },
        include_all_day_events: parseInt(values.includeAllDayEvents, 10),
        maintain_event_id: values.maintainEventId === 'true',
        reminders: values.useReminders ? values.reminders : null,
        sync_past_events: values.syncPastEvents,
        past_events_lookback_days: values.syncPastEvents ? values.pastEventsLookbackDays : null,
    };

    if (values.filterRuleField) {
        content.filter_rule = {
            field: values.filterRuleField,
            kind: values.filterRuleType,
            value: values.filterRule,
            filter_in: values.filterIn,
        };
    }

    if (!rule) {
        content.source_calendar_uuid = values.source;
        content.destination_calendar_uuid = values.destination;
    }

    return content;
}

export async function submitSyncRule(
    values: SyncRuleFormValues,
    rule: SyncRule | null,
): Promise<Response> {
    const content = buildSyncRulePayload(values, rule);
    return authFetch(`${API}/sync${rule ? `/${rule.uuid}` : ''}`, {
        method: rule ? 'PATCH' : 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(content),
    });
}
